import React from 'react';

import WebpWithFallback from '@swf/components/WebpWithFallback/WebpWithFallback';
import { Size } from '@swf/core/enums';
import useScreenSize from '@swf/core/hooks/useScreenSize';

import topTearPNG from '../assets/top-tear.png';
import topTear from '../assets/top-tear.webp';

import styles from './Steps.scss';

const stepsContent = [
  {
    title: 'Login or sign up',
    text: 'Login or Create Stars Account'
  },
  {
    title: 'Create your game',
    text: 'Create the Game YOU WANT using our quick and easy process'
  },
  {
    title: 'Add friends and play',
    text: 'Share your game link with friends and play together!'
  }
];

export const Steps: React.FC = () => {
  const { greaterThan } = useScreenSize();

  const isMobileDevice = !greaterThan(Size.Medium);

  return (
    <>
      {isMobileDevice && (
        <WebpWithFallback src={topTear} srcFallback={topTearPNG} containerClassName={styles.tear} />
      )}
      <section className={styles.steps}>
        <div className={styles.inner}>
          {stepsContent.map(({ title, text }, index) => (
            <div key={title} className={styles.step}>
              <div className={styles.left}>{index + 1}</div>
              <div className={styles.right}>
                <div className={styles.title}>{title}</div>
                <div className={styles.text}>{text}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
